import type { PlaceValueDigits } from './CrystalNumberBuilderConfig.js';
import type { StarBridgeState } from '../NumberKingdomState.js';

export interface NumberCoreChallengeConfig {
  id: string;
  skillId: string;
  target: number;
  initial: PlaceValueDigits;
  completionBridgeState: StarBridgeState;
}

export const STAR_BRIDGE_NUMBER_CORE_3: NumberCoreChallengeConfig = {
  id: 'star-bridge-number-core-1',
  skillId: 'math-place-value-diagnose',
  target: 352,
  initial: { hundreds: 3, tens: 4, ones: 2 },
  completionBridgeState: 'repair-3',
};
